import React, { useState, useEffect } from 'react';
import '../../styles/designation.css';
import '../../styles/ScopePopup.css';
import { toast } from 'react-toastify';

const DesignationCreation = ({ onClose, onSubmit, isEditMode, initialData }) => {
  const [formData, setFormData] = useState({
    designation_name: '',
    designation_code: '',
    description: ''
  });

  useEffect(() => {
    if (isEditMode && initialData) {
      setFormData({
        designation_name: initialData.designation_name,
        designation_code: initialData.designation_code,
        description: initialData.description
      });
    } else {
      setFormData({
        designation_name: '',
        designation_code: '',
        description: ''
      });
    }
  }, [isEditMode, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {

    if (!formData.designation_code) {
      toast.error("Designation Code is required");
      return;
    }
    if (!formData.designation_name)  {
      toast.error("Designation Name is required");
      return;
    }

    onSubmit(formData);
  };

  const handleClear = () => {
    setFormData({ 
      designation_name: '', 
      designation_code: '', 
      description: '' 
    });
  };

  return (
    <div className="designation-creation-popup-overlay">
      <div className="designation-creation-popup-container">
        <div className="designation-creation-popup-header">
          <h2>{isEditMode ? 'Edit Designation' : 'Create New Designation'}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="designation-creation-popup-body">
          <div className="designation-creation-form-group">
            <label>Code  <span style={{ color: 'red' }}>*</span></label>
            <input 
              name="designation_code" 
              value={formData.designation_code} 
              onChange={handleChange} 
              placeholder="Enter code ..." 
            />
          </div>
          <div className="designation-creation-form-group">
            <label>Name  <span style={{ color: 'red' }}>*</span></label>
            <input 
              name="designation_name" 
              value={formData.designation_name} 
              onChange={handleChange} 
              placeholder="Enter name ..." 
            />
          </div>
          <div className="designation-creation-form-group">
            <label>Description</label>
            <textarea 
              name="description" 
              value={formData.description} 
              onChange={handleChange} 
              placeholder="Enter description ..." 
            />
          </div>
        </div>
        <div className="designation-creation-popup-footer">
          <button className="clear-button" onClick={handleClear}>Clear</button>
          <button className="submit-button" onClick={handleSubmit}>
            {isEditMode ? 'Update' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DesignationCreation;